// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .required {
        color: red;
      }

      .invalid-field {
        border: 1px solid red;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/shared/picklist/picklist-select.component.ts"],"names":[],"mappings":";MACM;QACE,UAAU;MACZ;;MAEA;QACE,qBAAqB;MACvB","sourcesContent":["\n      .required {\n        color: red;\n      }\n\n      .invalid-field {\n        border: 1px solid red;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
